import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { ChatLogsState, ChatLogsT } from '../../types/chat';
import { chatEndpoints } from '../../services/api/endpoints/chat.endpoint';
import { logger } from '../../utils/logger';

const initialState: ChatLogsState = {
  items: [],
  selectedLog: null,
  unreadCount: 0,
  isLoading: false,
  error: null,
  selectedMonthYear: null,
};

// Fetch Chat logs thunk
export const fetchChatLogs = createAsyncThunk(
  'chatLogs/fetchAll',
  async (organizationId: string) => {
    try {
      const chatLogs = await chatEndpoints.getChatLogs(organizationId);
      // const unreadCount = chatLogs.filter((item: ChatLogsT) => !item.isViewed).length;
      return chatLogs;
    } catch (error) {
      logger.error('Failed to fetch chat logs:', error);
      throw error;
    }
  }
);

const chatLogsSlice = createSlice({
  name: 'chatlogs',
  initialState,
  reducers: {
    updateChatViewLog: (state, action: PayloadAction<ChatLogsT>) => {
      const index = state.items.findIndex((item: ChatLogsT) => item.uuid === action.payload.uuid);
      if (index !== -1) {
        state.items[index].isViewed = true;
      }
      state.unreadCount = state.items.filter((item: ChatLogsT) => !item.isViewed).length;
    },
    setUnreadCount: (state, action: PayloadAction<number>) => {
      state.unreadCount = action.payload;
    },
    setSelectedChatLog: (state, action: PayloadAction<ChatLogsT | null>) => {
      state.selectedLog = action.payload;
    },
    setSelectedMonthYear: (state, action: PayloadAction<string | null>) => {
      if (action.payload) {
        state.selectedMonthYear = action.payload;
      }
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchChatLogs.pending, state => {
        state.isLoading = true;
      })
      .addCase(fetchChatLogs.fulfilled, (state, action) => {
        state.isLoading = false;
        state.items = action.payload;
        state.unreadCount = state.items.filter((item: ChatLogsT) => !item.isViewed).length;
        state.selectedMonthYear = null;
      })
      .addCase(fetchChatLogs.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || 'Failed to fetch chat logs';
      });
  },
});

export const { updateChatViewLog, setSelectedChatLog, setSelectedMonthYear, setUnreadCount } =
  chatLogsSlice.actions;
export default chatLogsSlice.reducer;
